import { db } from "./firebase";
import { deleteDoc, doc } from "firebase/firestore";
import { getImagesById, deleteImageFromStorage } from "./saveImg";

export const deleteProperty = async (propertyId) => {
  try {
    // Eliminar imágenes del storage
    const imageUrls = await getImagesById(propertyId);
    await Promise.all(
      imageUrls.map(async (imageUrl) => {
        await deleteImageFromStorage(imageUrl);
      })
    );

    // Eliminar el documento de Firestore
    const propertyRef = doc(db, "propiedades", propertyId);
    await deleteDoc(propertyRef);

    console.log("Propiedad eliminada con éxito");
  } catch (error) {
    console.error("Error al eliminar la propiedad:", error);
    throw error;
  }
};
